//
export default [{
        path: '/availableEquity',
        component: resolve => require(['../pages/legalRight/availableEquity/availableEquity.vue'], resolve),
        name: 'availableEquity',
        title: "可用权益",
        meta: {
            title: "可用权益"
        }
    },
    {
        path: '/equitytemplateType',
        component: resolve => require(['../pages/legalRight/equitytemplateType/equitytemplateType.vue'], resolve),
        name: 'equitytemplateType',
        title: "权益模板分类",
        meta: {
            title: "权益模板分类"
        }
    },
    {
        path: '/equityTemplate',
        component: resolve => require(['../pages/legalRight/equityTemplate/equityTemplate.vue'], resolve),
        name: 'equityTemplate',
        title: "权益模板",
        meta: {
            title: "权益模板"
        }
    },
    {
        path: '/rightLevelRelation',
        component: resolve => require(['../pages/legalRight/rightLevelRelation/rightLevelRelation.vue'], resolve),
        name: 'rightLevelRelation',
        title: "等级与权益模板管理",
        meta: {
            title: "等级与权益模板管理"
        }
    },
    {
        path: '/vipcardManage',
        component: resolve => require(['../pages/legalRight/vipcardManage/vipcardManage.vue'], resolve),
        name: 'vipcardManage',
        title: "会员卡管理",
        meta: {
            title: "会员卡管理"
        }
    },
    {
        path: '/userRightsList',
        component: resolve => require(['../pages/userManage/userRightsList.vue'], resolve),
        name: 'userRightsList',
        title: "用户权益列表",
        meta: {
            title: "用户权益列表"
        }
    }
]